class StoreListing extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.handleTriggerClick = this.handleTriggerClick.bind(this)

    this.els?.trigger?.elements?.forEach((trigger) => {
      trigger.addEventListener('click', this.handleTriggerClick)
    })
  }

  handleTriggerClick (e) {
    const locationHandle = e.target?.dataset.locationHandle
    if (!locationHandle) return

    this.updateTriggerStates(locationHandle)
    this.filterCards(locationHandle)
  }

  updateTriggerStates (locationHandle) {
    this.els?.trigger?.elements?.forEach((trigger) => {
      trigger.setAttribute(
        'aria-pressed',
        trigger.dataset.locationHandle === locationHandle,
      )
    })
  }

  filterCards (locationHandle) {
    this.els?.card?.elements?.forEach((card) => {
      card.setAttribute(
        'aria-hidden',
        card.dataset.locationHandle !== locationHandle,
      )
    })
  }
}

if (!customElements.get('store-listing')) {
  customElements.define('store-listing', StoreListing)
}
